import naja from 'naja'
import SmoothScroll from 'smooth-scroll';

export default class WeseusScrollExtension {
	constructor(naja, options) {
		this.options = options || {};
		this.smoothScroll = new SmoothScroll();

		naja.addEventListener('init', this._init.bind(this));
		naja.addEventListener('interaction', this._interaction.bind(this));
		naja.addEventListener('complete', this._complete.bind(this));
	}

	_init() {
		document.addEventListener('click', (event) => {
			const elem = event.target.closest('[data-toggle="scroll"],[data-toggle="scroll-ajax"]');

			if (!elem) return;

			const toggle = elem.getAttribute('data-toggle'),
				target = elem.getAttribute('data-target');

			const anchor = document.querySelector(target || 'body');

			if (!anchor) {
				console.error('anchor "%s" not found', target);
				return;
			}

			if (toggle === 'scroll') {
				if (!elem.classList.contains('ajax') || elem.hasAttribute('data-ajax-href')) {
					event.preventDefault();
				}
				this._scroll(anchor, elem);

				return;
			}

			this.anchor = anchor;
			this.toggle = elem;
		});
	}

	_interaction(e) {
		e.options.scroll = {
			anchor: this.anchor,
			toggle: this.toggle,
		};
		this.anchor = null;
		this.toggle = null;
	}

	_complete(e) {
		if (e.options.scroll && e.options.scroll.anchor && e.options.scroll.toggle) {
			this._scroll(e.options.scroll.anchor, e.options.scroll.toggle)
		}

		// scroll triggered by ajax response
		if (e.response && e.response.scrollTo) {
			const anchor = document.querySelector(e.response.scrollTo);
			if (anchor) {
				// provide response as "toggle"
				this._scroll(anchor, e.response);
			}
		}
	}

	_scroll(anchor, toggle) {
		this.smoothScroll.animateScroll(anchor, toggle, this.options);
	}

}